import { createI18n } from 'vue-i18n';
import fr from './i18n/fr.json';
import en from './i18n/en.json';

const messages = {
    fr,
    en,
};

function getCurrentLocale() {
    const htmlLang = document.documentElement.lang;
    return htmlLang ? htmlLang.split('-')[0] : 'fr';
}

const locale = getCurrentLocale();

const i18n = createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'fr',
    messages,
});

export default i18n;
